"use client";
import CloseIcon from "@mui/icons-material/Close";
import {
  type ComponentPropsWithoutRef,
  type MouseEventHandler,
  type PropsWithChildren,
  useEffect,
  useRef,
} from "react";
import Portal from "@/components/common/Portal";
import s from "./Backdrop.module.scss";

export interface BackdropProps {
  open: boolean;
  onClose: ComponentPropsWithoutRef<"div">["onClick"];
}

export default function Backdrop(props: PropsWithChildren<BackdropProps>) {
  const { open, onClose, children } = props;

  const ref = useRef<HTMLDivElement>(null!);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  const handleClose: MouseEventHandler<HTMLDivElement> = (e) => {
    if (e.target !== ref.current) return;
    onClose?.(e);
  };

  if (!open) return null;

  return (
    <Portal targetId="backdrop-portal">
      <div ref={ref} onClick={handleClose} className={s.backdrop}>
        {children}
        <div className={s.closeButton} onClick={onClose}>
          <CloseIcon />
        </div>
      </div>
    </Portal>
  );
}
